<template>
    <div class="node-properties-inner">
        <selector :options="[
            { value: 'single-day', label: 'Single Day' },
            { value: 'range', label: 'Range' }
        ]" v-model="properties.rangeKind" />

        <label>{{ properties.rangeKind == 'single-day' ? "Date" : "From" }}</label>
        <input v-model="properties.fromTimeAndDate">

        <template v-if="properties.rangeKind == 'range'">
            <label>To</label>
            <input v-model="properties.toTimeAndDate">
        </template>
    </div>
</template>

<script>
import Selector from "@/components/nodes/Selector.vue";

export default {
    props: {
        properties: { type: Object, required: true }
    },
    components: { Selector }
}
</script>